import { isDomains } from "../../../react/applications/researcher/util/is-domains";

export const formats = {
  cssUnitFormat:
    "^(auto|0|(-?\\d*(\\.\\d+)?(em|ex|%|px|cm|mm|in|pt|pc|ch|rem|vh|vw|vmin|vmax))){0,1}$",
  domains: isDomains,
  integerFormat: "^[+-]?[0-9]+$",
  hexColorFormat: "^(#([0-9a-fA-F]{3}){1,2})?$",
  phoneMatcherFormat: "^\\+?\\d{6,15}$",
  positiveIntegerFormat: "^[0-9]*$",
  floatFormat: "^[+-]?[0-9]*([.][0-9]+)?$",
  positiveFloatFormat: "^[0-9]*([.][0-9]+)?$",
  slugFormat: "^[a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*$",
  variableNameFormat: "^[a-zA-Z_$][a-zA-Z_$0-9]*$",
};
